/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment, useState } from 'react'

import { EuiButtonEmpty } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import RecalculateFlyout from './RecalculateFlyout'

interface Props {
  organizationId: string
}

const RecalculateButton = ({ organizationId }: Props) => {
  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false)

  return (
    <Fragment>
      <EuiButtonEmpty size='s' onClick={() => setIsFlyoutOpen(true)}>
        <FormattedMessage
          id='organization.organization-overview.recalculate-account-button.button-text'
          defaultMessage='Recalculate usage'
        />
      </EuiButtonEmpty>

      {isFlyoutOpen && (
        <RecalculateFlyout organizationId={organizationId} onClose={() => setIsFlyoutOpen(false)} />
      )}
    </Fragment>
  )
}

export default RecalculateButton
